<script>
  import { createEventDispatcher } from 'svelte'
  import generateNavigationOptions from './generateNavigationOptions'
  import { PREVIOUS_PAGE, NEXT_PAGE, ELLIPSIS } from './symbolTypes'

  const dispatch = createEventDispatcher()
  export let totalItems = 0
  export let pageSize = 1
  export let currentPage = 1
  export let limit = null
  export let showStepOptions = false
  $: options = generateNavigationOptions({
    totalItems,
    pageSize,
    currentPage,
    limit,
    showStepOptions,
  })
  $: totalPages = Math.ceil(totalItems / pageSize)
  function handleOptionClick(option) {
    dispatch('setPage', { page: option.value })
  }
</script>

<div class="light-pagination-nav">
  <div class="pagination-nav">
    {#each options as option}
      <span
        class="option"
        class:number={option.type === 'number'}
        class:prev={option.type === 'symbol' && option.symbol === PREVIOUS_PAGE}
        class:next={option.type === 'symbol' && option.symbol === NEXT_PAGE}
        class:disabled={(option.type === 'symbol' &&
          option.symbol === NEXT_PAGE &&
          currentPage >= totalPages) ||
          (option.type === 'symbol' && option.symbol === PREVIOUS_PAGE && currentPage <= 1)}
        class:ellipsis={option.type === 'symbol' && option.symbol === ELLIPSIS}
        class:active={option.type === 'number' && option.value === currentPage}
        on:click={() => handleOptionClick(option)}
      >
        {#if option.type === 'number'}
          <slot name="number" value={option.value}>
            <span>{option.value}</span>
          </slot>
        {:else if option.type === 'symbol' && option.symbol === ELLIPSIS}
          <slot name="ellipsis">
            <span>...</span>
          </slot>
        {:else if option.type === 'symbol' && option.symbol === PREVIOUS_PAGE}
          <slot name="prev">
            <svg style="width:18px;height:18px" viewBox="0 0 24 24">
              <path
                fill="#000000"
                d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"
              />
            </svg>
          </slot>
        {:else if option.type === 'symbol' && option.symbol === NEXT_PAGE}
          <slot name="next">
            <svg style="width:18px;height:24px" viewBox="0 0 24 24">
              <path
                fill="#000000"
                d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
              />
            </svg>
          </slot>
        {/if}
      </span>
    {/each}
  </div>
</div>

<style global>
  .light-pagination-nav .pagination-nav {
    display: flex;
    justify-content: center;
    background: #fff;
    padding: 40px 0;
  }

  .light-pagination-nav .option {
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s all ease-out;
    user-select: none;
    color: var(--colorTextBody);
    font-family: var(--typeHeaderPrimary), var(--typeHeaderFallback);
  }

  .light-pagination-nav .option.number,
  .light-pagination-nav .option.ellipsis {
    padding: 6px 10px;
    width: 36px;
    line-height: 1;
  }

  .light-pagination-nav .option:hover {
    background: rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }

  .light-pagination-nav .option.active {
    background-color: var(--colorBrandPri);
    color: var(--colorBtnPrimaryText);
    font-weight: bold;
  }
</style>
